export const weekDays = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};

export const SlotTimeDisplay = [
  { title: "9 AM - 10 AM", value: "9 AM" },
  { title: "10 AM - 11 AM", value: "10 AM" },
  { title: "11 AM - 12 PM", value: "11 AM" },
  { title: "12 PM - 1 PM", value: "12 PM" },
  { title: "1 PM - 2 PM", value: "1 PM" },
  { title: "2 PM - 3 PM", value: "2 PM" },
  { title: "3 PM - 4 PM", value: "3 PM" },
  { title: "4 PM - 5 PM", value: "4 PM" },
  { title: "5 PM - 6 PM", value: "5 PM" },
  { title: "6 PM - 7 PM", value: "6 PM" },
];
